import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/banyan/src/Pebbles/select';
import { getTranslatedText, useIntl } from '@nile/components';
import { useStateList } from '@nile/components/src/Constants/stateslist/getstates';
import { isEmpty } from 'lodash';

function CountryListDropDown(props) {
  const { countryCode, placeholderkey, labelkey, handleFunction } = props;

  const converToDropdownStructure = (data = []) => {
    return data
      .map((item) => ({
        ...item,
        value: item.isoCode,
        label: item.name
      }))
      .sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      });
  };
  const intl = useIntl();
  const country = useStateList('country');
  const [countryList, setCountryList] = useState([]);
  const [currentSelectedCountry, setCurrentSelectedCountry] = useState(
    !isEmpty(countryCode)
      ? {
          value: countryCode,
          label: countryCode
        }
      : null
  );

  const onDropdownChange = (selectedCountry) => {
    setCurrentSelectedCountry(selectedCountry);
    handleFunction(selectedCountry);
  };

  useEffect(() => {
    const structuredCountries = converToDropdownStructure(country);
    setCountryList(structuredCountries);
    const currCountry = country.find((ct) => ct.isoCode === countryCode);
    if (currCountry) {
      const currentCountry = converToDropdownStructure(
        currCountry ? [currCountry] : []
      );
      setCurrentSelectedCountry(currentCountry);
    }
  }, [country, countryCode]);

  return (
    <div>
      <Select
        value={currentSelectedCountry}
        label={getTranslatedText(intl, labelkey)}
        options={countryList}
        onChange={onDropdownChange}
        components={{ IndicatorSeparator, DropdownIndicator }}
        classNamePrefix="value_selector"
        formatGroupLabel={formatGroupLabel}
        menuPlacement="auto"
        placeholder={getTranslatedText(intl, placeholderkey)}
        menuPortalTarget={document.body}
        closeMenuOnScroll={(e) => {
          return (
            e.target &&
            e.target.classList &&
            !(e.target.classList.value.indexOf('menu-list') > -1)
          );
        }}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 })
        }}
      />
    </div>
  );
}
export default CountryListDropDown;
